export const isSandbox = () => {
  const apiPath = process.env.REACT_APP_API

  return Boolean(apiPath && apiPath.includes("sandbox"))
}
